import React from 'react';
import AppHeader from 'src/common/ui/AppHeader';
import LandingNavContent from './components/LandingNavContent';
import MainContent from './components/MainContent/MainContent';
import Footer from './components/Footer/Footer';

const LandingPage = () => {
  return (
    <>
      <AppHeader navContent={<LandingNavContent />} hideDarkModeToggle />
      <main id="main-content">
        <MainContent />
      </main>
      <Footer />
    </>
  );
};

export default LandingPage;
